import { render } from "./QuickActions.vue?vue&type=template&id=4a7be9e7&scoped=true"
import script from "./QuickActions.vue?vue&type=script&lang=js"
export * from "./QuickActions.vue?vue&type=script&lang=js"

import "./QuickActions.vue?vue&type=style&index=0&id=4a7be9e7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7be9e7"]])

export default __exports__